let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jO9JA")).then(() => parcelRequire('jI7oG'));